import { z } from "zod";
import { CoachToneSchema, PathwayStyleSchema } from "./onboarding";

export const ProfileSchema = z.object({
  id: z.string().uuid(),
  displayName: z.string().min(1).max(80).nullable(),
  locale: z.string().default("sv-SE"),
  timezone: z.string().default("Europe/Stockholm"),
  onboardingCompletedAt: z.string().datetime().nullable(),
  preferredCoachTone: CoachToneSchema.nullable(),
  availableMinutes: z.number().int().positive().nullable(),
  currentProgramId: z.string().uuid().nullable(),
  joyPathway: PathwayStyleSchema.nullable().optional(),
  calmPathway: PathwayStyleSchema.nullable().optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type Profile = z.infer<typeof ProfileSchema>;
